import { useMemo } from "react";
import DOMPurify from "dompurify";
import { cn } from "~/lib/utils";

const ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "p",
  "ul",
  "ol",
  "li",
  "strong",
  "em",
  "br",
];

interface Props {
  html: string;
  className?: string;
}

/** Render a quiz question's reason — restricted HTML (headings, paragraphs, lists, emphasis). */
export function QuizReason({ html, className }: Props) {
  const sanitized = useMemo(
    () => DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR: [] }),
    [html],
  );

  return (
    <div
      className={cn(
        "space-y-2 text-sm [&_h1]:text-base [&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-medium [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5",
        className,
      )}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
